// extracted by mini-css-extract-plugin
export default {"selectedLanguage":"K9A4i a8cCT"};